<template>
  <div>
    <pageTitle :pageTitle="$t('lang.k_292001')">
      <div slot="content">
        {{ $t('lang.k_292002') }}
        <br />
        {{ $t('lang.k_292003') }}
      </div>
    </pageTitle>
    <!-- 模式选择 -->
    <div class="set-box">
      <vh-tabs v-model="tabType" @tab-click="handleClick">
        <vh-tab-pane :label="$t('lang.k_292004')" name="viewerCount"></vh-tab-pane>
        <vh-tab-pane :label="$t('lang.k_292005')" name="likesCount"></vh-tab-pane>
      </vh-tabs>
      <div class="virtual-ctx">
        <vh-form
          v-if="tabType == 'viewerCount'"
          :model="virtualForm"
          ref="virtualForm"
          :rules="virtualFormRules"
          label-width="100px"
          width="360px"
        >
          <vh-form-item :label="$t('lang.k_292006')">
            <vh-radio-group v-model="virtualForm.virtual_type">
              <vh-radio :label="1">{{ $t('lang.k_292007') }}</vh-radio>
              <vh-radio :label="2">{{ $t('lang.k_292008') }}</vh-radio>
            </vh-radio-group>
          </vh-form-item>
          <vh-form-item
            :label="$t('lang.k_292009')"
            v-if="virtualForm.virtual_type == 2"
            prop="timerange"
          >
            <vh-date-picker
              style="width: 366px"
              v-model="virtualForm.timerange"
              type="datetimerange"
              :range-separator="$t('lang.k_292010')"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              :append-to-body="false"
              :start-placeholder="$t('lang.k_292011')"
              :end-placeholder="$t('lang.k_292012')"
              :picker-options="{
                disabledDate: disabledPastDate
              }"
            ></vh-date-picker>
          </vh-form-item>
          <vh-form-item :label="$t('lang.k_292013')" prop="online">
            <vh-input
              autocomplete="off"
              v-model.trim="virtualForm.online"
              :placeholder="$t('lang.k_292014')"
              class="btn-relative btn-two"
              @input="formatInputs($event, 'virtualForm', 'online')"
            >
              <vh-button type="text" class="no-border" size="mini" slot="append">
                {{ $t('lang.k_292015') }}
              </vh-button>
            </vh-input>
          </vh-form-item>
          <vh-form-item :label="$t('lang.k_292016')" prop="pv">
            <vh-input
              autocomplete="off"
              v-model.trim="virtualForm.pv"
              :placeholder="$t('lang.k_292017')"
              class="btn-relative btn-two"
              @input="formatInputs($event, 'virtualForm', 'pv')"
            >
              <vh-button type="text" class="no-border" size="mini" slot="append">
                {{ $t('lang.k_292018') }}
              </vh-button>
            </vh-input>
          </vh-form-item>
          <vh-form-item>
            <div class="notice">
              <p>{{ $t('lang.k_292019') }}</p>
              <template v-if="virtualForm.virtual_type == 1">
                <p>{{ $t('lang.k_292020') }}</p>
                <p>{{ $t('lang.k_292021') }}</p>
                <p>{{ $t('lang.k_292022') }}</p>
              </template>
              <template v-if="virtualForm.virtual_type == 2">
                <p>{{ $t('lang.k_292023') }}</p>
                <p>{{ $t('lang.k_292024') }}</p>
                <p>{{ $t('lang.k_292025') }}</p>
                <p>{{ $t('lang.k_292026') }}</p>
              </template>
            </div>
          </vh-form-item>
          <vh-form-item label="">
            <vh-button
              v-if="virtualForm.virtual_type == 2 && virtualForm.status == 1"
              type="primary"
              class="length152"
              @click.prevent.stop="stopVirtual"
              round
            >
              {{ $t('lang.k_292027') }}
            </vh-button>
            <vh-button
              v-else
              type="primary"
              class="length152"
              @click.prevent.stop="virtualSetSave"
              round
            >
              {{ virtualForm.virtual_type == 2 ? $t('lang.k_292028') : $t('lang.k_292029') }}
            </vh-button>
          </vh-form-item>
        </vh-form>
        <div class="like-content" v-if="tabType == 'likesCount'">
          <div class="like-info">
            <div class="like-item">
              <p class="count">{{ likesInfo.virtual_count + likesInfo.total }}</p>
              <p>{{ $t('lang.k_292030') }}</p>
            </div>
            <div class="like-item">
              <p class="count">{{ likesInfo.total }}</p>
              <p>{{ $t('lang.k_292031') }}</p>
            </div>
            <vh-button type="text" @click="getLikesInfo">
              {{ $t('lang.k_292032') }}
              <i class="vh-icon-refresh-right"></i>
            </vh-button>
          </div>
          <vh-form
            :model="virtualLikesForm"
            ref="likesForm"
            :rules="likesFormRules"
            label-width="100px"
            width="360px"
          >
            <vh-form-item :label="$t('lang.k_292033')" prop="add_virtual_like_count">
              <vh-input
                autocomplete="off"
                v-model.trim="virtualLikesForm.add_virtual_like_count"
                :placeholder="$t('lang.k_292034')"
                class="btn-relative btn-two"
                @input="formatInputs2($event, 'virtualLikesForm', 'add_virtual_like_count')"
              >
                <vh-button type="text" class="no-border" size="mini" slot="append">
                  {{ $t('lang.k_292018') }}
                </vh-button>
              </vh-input>
            </vh-form-item>
            <vh-form-item :label="$t('lang.k_292035')">
              <vh-select
                autocomplete="off"
                v-model="virtualLikesForm.like_times"
                :placeholder="$t('lang.k_292036')"
                class="btn-relative btn-two"
              >
                <vh-option v-for="m in multiples" :key="m" :value="m" :label="'x ' + m">
                  {{ 'x ' + m }}
                </vh-option>
              </vh-select>
              {{ $t('lang.k_292037') }}
            </vh-form-item>
            <vh-form-item>
              <div class="notice">
                <p>{{ $t('lang.k_292019') }}</p>
                <p>{{ $t('lang.k_292038') }}</p>
                <p>{{ $t('lang.k_292039') }}</p>
                <p>{{ $t('lang.k_292040') }}</p>
                <p>{{ $t('lang.k_292041') }}</p>
              </div>
            </vh-form-item>
            <vh-form-item label="">
              <vh-button type="primary" class="length152" @click.prevent.stop="likesSetSave" round>
                {{ $t('lang.k_292029') }}
              </vh-button>
            </vh-form-item>
          </vh-form>
        </div>
      </div>
    </div>
    <begin-play
      :webinarId="$route.params.str"
      v-if="$route.query.type != 5 && webinarState != 4"
    ></begin-play>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle';
  import beginPlay from '@/components/beginBtn';
  import { sessionOrLocal } from '@/utils/utils';
  import regRule from '@/utils/reg-rule.js';
  import { throttle } from 'lodash';
  export default {
    name: 'virtual.vue',
    components: {
      PageTitle,
      beginPlay
    },
    data() {
      // 校验人数
      let checkOnlineNum = (rule, value, callback) => {
        let pvCount = value > 0 ? Math.floor(Number(this.virtualForm.pv) * 0.8) : 0;
        if (!regRule.num7.test(value)) {
          return callback(new Error(this.$t('lang.k_292042')));
        } else if (this.virtualForm.pv < Number(value)) {
          return callback(new Error(this.$t('lang.k_292043')));
        } else {
          if (this.virtualForm.pv !== '') {
            this.$refs.virtualForm.clearValidate('pv');
          }
          callback();
        }
      };
      // 校验热度
      let checkPv = (rule, value, callback) => {
        let pvCount = value > 0 ? Math.floor(Number(value) * 0.8) : 0;
        if (!regRule.num7.test(value)) {
          return callback(new Error(this.$t('lang.k_292042')));
        } else if (this.virtualForm.online > Number(value)) {
          return callback(new Error(this.$t('lang.k_292044')));
        } else {
          if (this.virtualForm.online !== '') {
            this.$refs.virtualForm.clearValidate('online_num');
          }
          callback();
        }
      };
      return {
        webinarState: JSON.parse(sessionOrLocal.get('webinarState')),
        virtualForm: {
          virtual_type: 1, // 1立即生效、分时生效
          timerange: [], // 分时生效时间
          pv: null, // pv
          online: null // 在线人数
        },
        virtualLikesForm: {
          webinar_id: this.$route.params.str,
          add_virtual_like_count: '', //虚拟点赞数
          like_times: 1 //点赞倍数
        },
        virtualFormRules: {
          online: [{ validator: checkOnlineNum, trigger: 'blur' }],
          pv: [{ validator: checkPv, trigger: 'blur' }],
          timerange: [
            {
              validator: (rule, value, callback) => {
                if (!value || value.length < 2) {
                  callback(new Error(this.$t('lang.k_292045')));
                } else {
                  callback();
                }
              },
              trigger: 'change'
            }
          ]
        },
        multiples: Array.from({ length: 10 }, (v, k) => k + 1),
        likesFormRules: {
          add_virtual_like_count: [
            {
              validator: (rule, value, callback) => {
                if (value && !regRule.num7_2.test(value)) {
                  return callback(new Error(this.$t('lang.k_292046')));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ]
        },
        likesInfo: {
          total: 0,
          virtual_count: 0
        },
        tabType: 'viewerCount'
      };
    },
    watch: {
      $route: {
        handler: function (route) {
          let levelList = [
            {
              title: this.$t('lang.k_292047'),
              path: '/live/list',
              isClick: false
            },
            {
              title: this.$t('lang.k_292048'),
              path: '/live/list',
              isClick: true
            },
            {
              title: this.$t('lang.k_292048'),
              path: `/live/detail/${this.$params.str}`,
              isClick: true
            },
            {
              title: this.$t('lang.k_292049'),
              path: `/live/viewerRules/${this.$params.str}`,
              isClick: false
            }
          ];

          this.$EventBus.$emit('saas_vs_crumb_event', this.levelList);
        },
        immediate: true
      }
    },
    methods: {
      disabledPastDate(time) {
        return time.getTime() < Date.now() - 8.64e7;
      },
      formatInputs(value, formName, key) {
        if (!regRule.num7.test(value)) {
          this[formName][key] = '';
        } else {
          this[formName][key] = parseInt(value);
        }
      },
      formatInputs2(value, formName, key) {
        if (!regRule.num7_2.test(value)) {
          this[formName][key] = '';
        } else {
          this[formName][key] = parseInt(value);
        }
      },
      // 获取虚拟人数信息状态
      getVirtualInfo() {
        this.$fetch('virtualGet', {
          webinar_id: this.$route.params.str
        })
          .then(res => {
            if (res.data) {
              res.data.pv = res.data.pv === 0 ? null : res.data.pv;
              res.data.online = res.data.online === 0 ? null : res.data.online;
              res.data.timerange = res.data.begin_time
                ? [res.data.begin_time, res.data.end_time]
                : [];
              this.virtualForm = res.data;
            } else {
              this.virtualForm = {
                pv: null,
                online: null,
                virtual_type: 1
              };
            }
          })
          .catch(err => {
            console.log(err);
            this.virtualForm = {
              pv: null,
              online: null,
              virtual_type: 1
            };
          });
      },
      stopVirtual: throttle(
        function () {
          this.$fetch('virtualStop', {
            webinar_id: this.$route.params.str
          })
            .then(res => {
              if (res.code == 200) {
                this.virtualForm.status = 0;
                this.$vhMessage({
                  message: this.$t('lang.k_292050'),
                  showClose: true,
                  // duration: 0,
                  type: 'success',
                  customClass: 'zdy-info-box'
                });
              }
            })
            .catch(res => {
              console.log(res);
              this.$vhMessage;
            });
        },
        2000,
        { trailing: false }
      ),
      // 虚拟人数设置保存
      virtualSetSave: throttle(
        function () {
          let userId = JSON.parse(sessionOrLocal.get('userId'));
          this.$refs.virtualForm.validate(valid => {
            if (valid) {
              let params = {
                webinar_id: this.$route.params.str,
                pv: this.virtualForm.pv,
                virtual_type: this.virtualForm.virtual_type,
                online: this.virtualForm.online
              };
              if (params.virtual_type == 2) {
                params.begin_time = this.virtualForm.timerange[0];
                params.end_time = this.virtualForm.timerange[1];
              }
              this.$fetch('virtualSetSave', params)
                .then(res => {
                  if (res.code == 200) {
                    if (this.virtualForm.virtual_type == 2) {
                      this.virtualForm.status = this.virtualForm.status == 1 ? 0 : 1;
                    }
                    this.$vhall_paas_port({
                      k: 100136,
                      data: {
                        business_uid: userId,
                        user_id: '',
                        webinar_id: this.$route.params.str,
                        refer: '',
                        s: '',
                        report_extra: {},
                        ref_url: '',
                        req_url: ''
                      }
                    });
                    this.$vhMessage({
                      message: this.$t('lang.k_292051'),
                      showClose: true,
                      // duration: 0,
                      type: 'success',
                      customClass: 'zdy-info-box'
                    });
                  }
                })
                .catch(res => {
                  this.$vhMessage({
                    message: res.message || this.$t('lang.k_292052'),
                    showClose: true,
                    // duration: 0,
                    type: 'error',
                    customClass: 'zdy-info-box'
                  });
                });
            }
          });
        },
        2000,
        { trailing: false }
      ),
      //虚拟点赞设置
      likesSetSave() {
        this.$refs.likesForm.validate(valid => {
          if (valid) {
            this.$fetch('likesSetSave', this.virtualLikesForm)
              .then(res => {
                this.$vhMessage({
                  message: `${this.$t('lang.k_292051')}`,
                  showClose: true,
                  // duration: 0,
                  type: 'success',
                  customClass: 'zdy-info-box'
                });
                this.getLikesInfo();
              })
              .catch(res => {
                console.log(res);
                this.$vhMessage({
                  message: res.msg || `${this.$t('lang.k_292052')}`,
                  showClose: true,
                  // duration: 0,
                  type: 'error',
                  customClass: 'zdy-info-box'
                });
              });
          }
        });
      },
      getLikesSet() {
        this.$fetch('likesGet', { webinar_id: this.$route.params.str }).then(res => {
          this.virtualLikesForm.add_virtual_like_count = res.data.add_virtual_like_count || '';
          this.virtualLikesForm.like_times = res.data.like_times || '';
        });
      },
      getLikesInfo() {
        const liveDetailInfo = JSON.parse(sessionOrLocal.get('liveDetailInfo'));
        this.$fetch('getLikesInfo', { room_id: this.$route.query.roomId }).then(res => {
          this.likesInfo.total = res.data.total || 0;
          this.likesInfo.virtual_count = res.data.virtual_count || 0;
        });
      },
      handleClick() {
        if (this.tabType == 'likesCount') {
          this.getLikesInfo();
          this.getLikesSet();
        }
      }
    },
    created() {
      this.getVirtualInfo();
    }
  };
</script>

<style lang="less" scoped>
  .set-box {
    .layout--right--main;
  }
  .virtual-ctx {
    .padding41-40;
    .min-height;
    .btn-relative {
      position: relative;
    }
  }
  ::v-deep .vh-form-item__content > .vh-input {
    width: 366px;
  }
  ::v-deep .vh-select .vh-input {
    width: 100px;
  }
  .notice {
    p {
      font-size: 12px;
      color: #999999;
      margin: 0 0;
      line-height: 20px;
    }
  }
  .like-content {
    .like-info {
      display: flex;
      padding-left: 100px;
      width: 500px;
      text-align: center;
      padding-bottom: 40px;
      justify-content: space-between;
      .like-item {
        padding-right: 30px;
        p {
          text-align: center;
          font-size: 12px;
          color: #999;
          &.count {
            font-size: 24px;
            color: #262626;
            font-weight: 500;
            padding-bottom: 5px;
          }
        }
      }
    }
  }
</style>
<style>
  .virtual-ctx .vh-input-group__append {
    text-align: center;
  }
</style>
